import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {DataEntity, OctopusConnectService} from 'octopus-connect';
import {brand, cardLayout} from 'app/settings';
import {ModelSchema, Structures} from 'octopus-model';
import {modulesSettings} from '../../../app/settings';
import {map, mergeMap, take, tap} from 'rxjs/operators';
import {UserProgression} from 'fuse-core/components/home-page/home-page.component';
import {HomePageCollection} from "fuse-core/components/home-page/home-page.collection";
import {
    EducationalLevelCollection,
    GetEducationalLevelOptions
} from "fuse-core/components/first-time-user-experience/first-time-user-experience.service";
import {FilterData} from "octopus-connect";

const settingsStructure: ModelSchema = new ModelSchema({
    urlVideoException: Structures.array([]),
    isProgressionEnable: Structures.boolean(),
    redirectUserByRole: Structures.object(),
    showCollectionTitle: Structures.boolean(),
    concepts: Structures.array(),
    usePostHog:Structures.boolean(false),
    homeLudoCardView:Structures.boolean(false),
});

export interface Actuality {
    "id": number,
    "title": string,
    "created": number,
    "changed": number,
    "body": {
        "value": string,
        "summary": string
    },
    "collectivite":
        {
            "id": number,
            "name": string
        }[]
    ,
    "lien": {
        title: string,
        url: string
    },
    "image": {
        "url": string,
        "alt": string,
        "title": string
    }
}

@Injectable({
    providedIn: 'root'
})

export class HomePageService {
    public cardLayout = cardLayout;
    public settings: { [key: string]: any };
    public ftuxInitialized = false;
    public homePages = [] as HomePageCollection['entities'];
    public homePagesSubject = new BehaviorSubject<HomePageCollection['entities']>([]);

    constructor(private octopusConnect: OctopusConnectService) {
        this.settings = settingsStructure.filterModel(modulesSettings.homePage);
        this.loadHomePage().pipe(take(1), tap(homePageCollection => {
            this.homePages = homePageCollection.entities;
            this.homePagesSubject.next(homePageCollection.entities);
        })).subscribe();
    }

    public loadHomePage() {
        return this.octopusConnect.loadCollection('homepage_lms', {instance_name: brand}) as Observable<HomePageCollection>;
    }

    public loadUserProgression(userProgressFilter: {
        educationalLevel: string,
        concept: string,
        group?: string
    }): Observable<UserProgression> {
        return this.octopusConnect.loadCollection('user-progress', userProgressFilter).pipe(
            map((collection) => collection.entities[0].get('currentUser'))
        );
    }

    public loadEducationalLevels(options?: GetEducationalLevelOptions): Observable<EducationalLevelCollection> {
        return this.octopusConnect.loadCollection('educational_level', options?.filters) as Observable<EducationalLevelCollection>;
    }

    public loadActualities(options: FilterData = {}): Observable<DataEntity<Actuality>[]> {
        return this.octopusConnect.loadCollection('articles', options).pipe(take(1), map(collection => collection.entities as DataEntity<Actuality>[]));
    }

    public markFtuxAsDone(userEntity: DataEntity): Observable<DataEntity> {
        return this.octopusConnect.loadEntity('users', userEntity.id.toString()).pipe(
            take(1),
            mergeMap(user => {
                user.set('ftux_done', true)
                    return user.save();
            })
        )
    }
    public getUseHomeLudoCardView():boolean{
        return this.settings?.homeLudoCardView;
    }

}